// Sidebar behaviour constants. Widths, durations and easings live as CSS custom
// properties (--sb-*) in styles/SideBar.css so CSS and JS read a single source;
// only the values JS has to schedule against are mirrored here.

export const SIDEBAR_STATE = Object.freeze({
    COLLAPSED: 'collapsed', // 80px rail, icons only
    PEEK: 'peek', // expanded as an overlay; the page does not move
    PINNED: 'pinned', // expanded and the page reserves its width
})

// Hover intent: a pointer has to rest on the rail this long before it opens, and be
// gone this long before it closes, so grazing the rail on the way somewhere else
// does not flash the panel.
export const SIDEBAR_HOVER_OPEN_DELAY = 120
export const SIDEBAR_HOVER_CLOSE_DELAY = 250

// Upper bound for the reveal/FLIP transitions (--sb-dur-open plus slack). Used as a
// fallback to clean up when `transitionend` never fires (tab hidden, reduced motion).
export const SIDEBAR_TRANSITION_FALLBACK = 400

// The sidebar is pinned open by default; a teacher can unpin it and that choice
// sticks. The key name predates the pinned/peek model and is kept so existing
// preferences survive (true = unpinned).
export const SIDEBAR_COLLAPSED_KEY = 'sidebarCollapsed'

// Mirrors the `.nav-pin` hide rule in styles/SideBar.css. Below this width there is no
// pin control, so the rail keeps its hover-only behaviour instead of stranding the
// teacher with a 280px sidebar they cannot close.
export const SIDEBAR_PIN_AVAILABLE_QUERY = '(min-width: 1361px)'
